'use client';

import PropTypes from "prop-types";

const SelectInput = ({
  label,
  name,
  options = [],
  className = "",
  error = "",
  value = "",
  onChange,
  variant = "light",
  ...props
}) => {
  const variants = {
    light: "bg-color-98 text-color-1 border-color-50 focus:border-[var(--accent-dark)] hover:border-[var(--accent-dark)]",
    dark: "bg-[#09090b] text-gray-200 border-white/10 focus:border-white/20 hover:border-white/20",
  };
  
  const activeClass = variants[variant] || variants.light;

  return (
    <div className={`relative w-full ${className}`}>
      <select
        id={name}
        name={name}
        value={value}
        onChange={onChange}
        {...props}
        className={`peer w-full text-sm border rounded-md px-3 py-2 transition duration-300 ease focus:outline-none shadow-sm focus:shadow ${activeClass} ${
          error ? "border-red-500" : ""
        }`}
      >
        {/* <option disabled value="">
          Select {label}
        </option> */}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      <label
        htmlFor={name}
        className={`absolute -top-2 left-2.5 bg-color-98 px-1 text-xs text-color-1 w-fit ${
          error ? "text-red-500" : ""
        }`}
      >
        {label}
      </label>
      {error && <span className="text-red-500 text-xs mt-1">{error}</span>}
    </div>
  );
};

SelectInput.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.any.isRequired,
      label: PropTypes.string.isRequired,
    })
  ).isRequired,
  className: PropTypes.string,
  error: PropTypes.string,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default SelectInput;
